import React from "react";
import VisaImage from '../../images/payment-method-logos/visa.png';
import MastercardImage from '../../images/payment-method-logos/mastercard.png';
import AmexImage from '../../images/payment-method-logos/amex.png';
import DiscoverImage from '../../images/payment-method-logos/discover.png';
import DinersImage from '../../images/payment-method-logos/diners.png';
import JCBImage from '../../images/payment-method-logos/jcb.png';
import UnionpayImage from '../../images/payment-method-logos/unionpay.png';
import PaymentMethodDefaultImage from "../../images/payment-method-logos/default.png";

interface Props {
    paymentMethodName: string | undefined;
}

const PaymentMethodLogo: React.FC<Props> = ({paymentMethodName} :Props) => {
    const brandLogoSrc = (() => {
        switch (paymentMethodName) {
            case 'visa':
                return VisaImage;
            case 'mastercard':
                return MastercardImage;
            case 'amex':
                return AmexImage;
            case 'discover':
                return DiscoverImage;
            case 'diners':
                return DinersImage;
            case 'jcb':
                return JCBImage;
            case 'unionpay':
                return UnionpayImage;
            default:
                return PaymentMethodDefaultImage;
        }
    })();

    return <img alt={paymentMethodName || 'Payment Method'} src={brandLogoSrc} />;
};

export default PaymentMethodLogo;